import { createAction, props } from '@ngrx/store';
import { Card } from '../../models/card';
import { Contact } from '../../models/contact';

export const contactEditorSetId = createAction(
    '[Contact Editor] Set Id',
    props<{ id: string }>()
);

export const contactEditorSetCard = createAction(
    '[Contact Editor] Set Card',
    props<{ card: Partial<Card> }>()
);

export const contactEditorSetReference = createAction(
    '[Contact Editor] Set Reference',
    props<{ reference: string }>()
);
export const contactEditorSetAddressBookId = createAction(
    '[Contact Editor] Set Address Book Id',
    props<{ addressBookId: string }>()
);

export const contactEditorLoadRequest = createAction(
    '[Contact Editor] Load',
    props<{ id: string }>()
);

export const contactEditorLoadComplete = createAction(
    '[Contact Editor] Load Complete',
    props<{ contact: Contact }>()
);

export const contactEditorLoadFailure = createAction(
    '[Contact Editor] Load Failure'
);

export const contactEditorSaveRequest = createAction(
    '[Contact Editor] Save Request'
);

export const contactEditorSaveSuccess = createAction(
    '[Contact Editor] Save Succeeded'
);

export const contactEditorSaveFailure = createAction(
    '[Contact Editor] Save Failure'
);

export const contactEditorNew = createAction(
    '[Contact Editor] New'
);

export const contactEditorEdit = createAction(
    '[Contact Editor] Edit',
    props<{ id: string }>()
);

